export default __webpack_public_path__ + "static/media/MTD0137@2x.54a773fc.png";